import * as React from "react";
import { Fragment, HTMLProps, ReactNode, useEffect, useState } from "react";
import { mod } from "../technical/mod";
import styled from "styled-components";
import { SvgChevronLeft } from "./ChevronLeft";

interface Props {
  slides: Array<Array<ReactNode>>;
  isAutomatic?: boolean;
  style?: HTMLProps<HTMLDivElement>["style"];
}

const Container = styled.div`
  display: flex;
  overflow-x: hidden;
  margin: 24px;
`;

const Slide = styled.div<{ translateX: number }>`
  display: flex;
  min-width: 100%;
  transform: translateX(-${({ translateX }) => translateX}00%);
  transition: transform 0.6s ease;
`;

const Right = styled(SvgChevronLeft)`
  cursor: pointer;
  color: black;
  z-index: 99;
  position: absolute;
  top: 50%;
  width: 26px;
  right: 0;
  transform: translateY(-50%) rotate(180deg);
`;

const Left = styled(SvgChevronLeft)`
  cursor: pointer;
  color: black;
  z-index: 99;
  position: absolute;
  top: 50%;
  left: 0;
  width: 26px;
  transform: translateY(-50%);
`;

export const Slider = ({ slides, style, isAutomatic }: Props) => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (!isAutomatic) {
      return;
    }

    const interval = setInterval(() => {
      setActiveSlide(oldSlide => mod(oldSlide + 1, slides.length));
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [isAutomatic, slides]);

  return (
    <Container style={style}>
      {!isAutomatic && (
        <Right
          onClick={() => setActiveSlide(mod(activeSlide + 1, slides.length))}
        >
          RIGHT
        </Right>
      )}
      {!isAutomatic && (
        <Left
          onClick={() => setActiveSlide(mod(activeSlide - 1, slides.length))}
        >
          LEFT
        </Left>
      )}
      {slides.map((slide, i) => (
        <Slide key={i} translateX={activeSlide}>
          {slide.map((item, j) => (
            <Fragment key={j}>{item}</Fragment>
          ))}
        </Slide>
      ))}
    </Container>
  );
};
